<template>
    <div>
        <geo-watcher />

        <div class="header-background-gradient absolute h-96 w-full"></div>

        <div class="container mx-auto max-w-6xl p-5 flex flex-col min-h-screen">
            <header>
                <slot name="header">
                    <AuroraHeader />
                </slot>
            </header>

            <main class="flex-1 pt-5">
                <slot />
            </main>

            <footer>
                <slot name="footer">
                    <AuroraFooter />
                </slot>
            </footer>
        </div>

    </div>
</template>

<script>
import AuroraFooter from './AuroraFooter.vue'
import AuroraHeader from './AuroraHeader.vue'
import GeoWatcher from '../../components/GeoWatcher.vue'

    export default {
        components: { AuroraFooter, AuroraHeader, GeoWatcher },
        data() {
            return {
                
            }
        },
    }
</script>